import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { DropdownBox } from "../../dropdown";
import { useConfig } from "../../util";
import { CascaderMenuLists } from "./CascaderMenuLists";
import { CascaderMultiMenuLists } from "./CascaderMultiMenuLists";
export function CascaderMenuBox(_a) {
    var multiple = _a.multiple, className = _a.className, style = _a.style, props = __rest(_a, ["multiple", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(DropdownBox, { className: classNames(className, "size-auto-width"), style: style },
        React.createElement("div", { className: classPrefix + "-cascader-menu " + classPrefix + "-cascader-menu--thin" }, multiple ? (React.createElement(CascaderMultiMenuLists, __assign({}, props))) : (React.createElement(CascaderMenuLists, __assign({}, props))))));
}
CascaderMenuBox.displayName = "CascaderMenuBox";
//# sourceMappingURL=CascaderMenuBox.js.map